export default __webpack_public_path__ + "static/media/BDAR-logo_20.5.2023.67aef74a.png";